import Cookies from "js-cookie";

/* Ending a session, in one place.
 *
 * This was inline in Sidebar.jsx, which was fine while the sidebar owned the
 * only Logout control. Sensa's rail now has one too, and a second hand-copied
 * version of this list is the kind of duplicate that rots in one direction
 * only: someone adds a token to one path, the other keeps writing it to disk,
 * and a "logged out" browser is still holding credentials.
 *
 * Navigation is deliberately NOT done here. Where to send someone afterwards is
 * a routing decision belonging to the caller; this function's single job is to
 * leave nothing behind.
 */
export const clearSession = () => {
  // Razorpay leaves per-checkout keys and cookies behind under an rzp_ prefix.
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("rzp_")) localStorage.removeItem(key);
  });
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    if (name.startsWith("rzp_")) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    }
  });

  Cookies.remove("invitation_token");
  localStorage.removeItem("full_name");
  localStorage.removeItem("email");
  localStorage.removeItem("username");
  localStorage.removeItem("token");
  localStorage.removeItem("cachedWorkspaces");
  localStorage.removeItem("activeWorkspace");
  localStorage.removeItem("activeWorkspaceId");
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
  Cookies.remove("expires_on");
  Cookies.remove("selected_org_id");
  Cookies.remove("subscription_status");

  // The named removals above are kept rather than folded into these two: the
  // cookies are not covered by either clear(), and the explicit list documents
  // what this app actually stores.
  localStorage.clear();
  sessionStorage.clear();
};
